import { SessionHandler } from "verdi-web-client/APICommands/SessionHandler";

export interface WhoAmIResponse {
    accounts: Object[];
    admin: boolean;
    adminUsername: string;
    id: string;
    user: {
        defaultCoordinates: { lat: number; lng: number };
    };
}

export const getWhoAmI = async (): Promise<WhoAmIResponse> =>
    SessionHandler.doFetch("WhoAmI", {
        headers: {
            "Content-Type": "application/json",
        },
        method: "GET",
        redirect: "follow",
    })
        .then((res) => res.json())
        .catch(async (error) => {
            const messageObj = await error?.message?.json();
            throw new Error(messageObj?.message ?? "");
        });
